import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function BallIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 22 23" {...props}>
      <Box
        as="circle"
        cx="11"
        cy="11.921"
        r="10.46"
        fill="#fff"
        stroke="#CAF23A"
        strokeWidth="1.079"
        transform="rotate(90 11 11.92)"
      />
      <Box as="circle" cx="11" cy="11.921" r="9" fill="#CAF23A" transform="rotate(90 11 11.92)" />
    </Icon>
  );
}
